import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]

import {computed} from "vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'ResultItem',
  props: {
    index: {},
    resultType: {},
    result: {},
    displayResult: {},
    copyResult: { type: Boolean },
    resultId: {},
    thumbnailUrl: {},
    selected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const title = computed(() => {
    return props.copyResult || !props.displayResult ? props.result : props.displayResult
})

const url = computed(() => {
    if (props.resultType === "video"){
        return `/v/${props.resultId}`;
    }else if (props.result){
        return `/search/?q=${encodeURIComponent(props.result)}`
    }else{
        return ""
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    key: _ctx.index,
    id: `result-${_ctx.index}-${_ctx.selected}`,
    class: _normalizeClass({'bg-mono-ps-100': _ctx.selected})
  }, [
    _createElementVNode("a", {
      href: url.value,
      class: "flex items-center gap-2"
    }, [
      (_ctx.thumbnailUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "w-10 h-10 object-cover",
            src: _ctx.thumbnailUrl
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(title.value), 1)
    ], 8, _hoisted_2)
  ], 10, _hoisted_1))
}
}

})